import { Formik } from "formik";
import { useEffect, useState } from "react";
import InputFormik from "../../../../../../components/InputFormik";
import useAppData from "../../../../../../hook/useAppData";
import { postSeniority, putSeniority } from "../../../../service";
// import { getSeniority, postSeniority, putSeniority } from "../../../../service";
import "./index.scss";

interface ValuesProps {
  name: string;
}

const initialValues: ValuesProps = {
  name: "",
};

function FormSeniorityPosition({ id, List, setModalStatus, getSeniority }: any) {
  const [updateValue, setUpdateValue] = useState(initialValues);
  const { token } = useAppData();

  useEffect(() => {
    List?.map((item: any) => {
      if (item.id === id) {
        setUpdateValue(item);
      }
    });
  }, []);

  async function handleFormSubmit(value: any) {
    if (typeof value === "object") {
      value = value.name;
    }

    const body = {
      name: value,
    };

    if (id) {
      return putSeniority(body, id, token).then((data) => {
        if (data?.ok) {
          setModalStatus(false);
          getSeniority();
        }
      });
    }
    const data = await postSeniority(body, token);
    if (data?.ok) {
      setModalStatus(false);
      getSeniority();
    }
  }

  return (
    <div className="jobPositionContainer">
      <Formik
        initialValues={updateValue}
        onSubmit={() => {
          handleFormSubmit(updateValue);
        }}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <h1 className="title-form">{!id ? `Cadastro de ` : `Atualizar`} Senioridade</h1>
            <div className="center">
              <InputFormik
                className=""
                name="name"
                onChange={(e: any) => {
                  setUpdateValue({ ...updateValue, name: e.target.value });
                  props.handleChange(e);
                }}
                onBlur={(e: any) => {
                  setUpdateValue({ name: e.target.value });
                  props.handleBlur(e);
                }}
                value={updateValue.name}
                placeholder="Digite uma Senioridade"
                type="text"
                required={true}
                autofocus={false}
              />
              <button className="btn bg-secondary" type="submit">
                Salvar
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default FormSeniorityPosition;
